import { NotificationsNavigation } from './navigation'
import { NotificationsScreens } from './screens'
import { NotificationsStatsig } from './statsig'
import { NotificationComponents } from './components'
import { NotificationsStore } from './store'
import * as Hooks from './hooks'

export const Notifications = {
  Screens: NotificationsScreens,
  Statsig: NotificationsStatsig,
  Navigation: NotificationsNavigation,
  Components: NotificationComponents,
  Store: NotificationsStore,
  Hooks,
  Icons: {},
}
